module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Piers Anthony\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v(" Piers Anthony is one of the world’s most popular fantasy writers, and a "), _c('I', [_vm._v("New York Times")]), _vm._v("–bestselling author twenty-one times over. His Xanth novels have been read and loved by millions of readers around the world, and he daily receives letters from his devoted fans. In addition to the Xanth series, Anthony is the author of many other bestselling works. He lives in Inverness, Florida. ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/hdQNlj/tc-custom/9781504089432.jpg?1731883397541",
      "alt": "This image is the cover for the book Question Quest, The Xanth Novels"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Question Quest, The Xanth Novels\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("A magician sends a melancholic maiden on a rescue mission in Hell in this humorous fantasy adventure by a "), _c('i', [_vm._v("New York Times")]), _vm._v("–bestselling author.")])]), _c('p', [_vm._v(" As one of the trouble-making twins of Castle Zombie, Lacuna used to have so much fun when she was a little girl. But now at thirty-four, she’s bored stiff and wonders where her life went horribly wrong. To escape her funk, she heads to Good Magician Grey to pose a question. Of course, in Xanth, getting an answer is far from simple . . .  ")]), _c('p', [_vm._v(" Grey sends Lacuna to Hell in a handbasket . . . literally. There, she meets Good Magician Humfrey, who’s spent the last ten years waiting to get his wife back from a terrible demon. With her magical talents—and a few gorgons—Lacuna just might be able to help Humfrey, escape Hell alive, and fix her boring life, once and for all. ")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0